let nl = {
  _confirm: "Bevestigen",
  _cancel: "Annuleren",
  _completed: "Completed",
  _date: "Datum",
  _delete: "Verwijderen",
  _days: "dagen",
  _email: "E-mail",
  _to: "Naar",
  _from: "Van",
  _login: "Aanmelden",
  _loggedout: "Afgemeld",
  _loggedout_message: "U bent afgemeld. U kunt dit venster sluiten.",
  _mobileNumber: "Mobiel telefoonnummer",
  _name: "Naam",
  _phonenumber: "Telefoonnummer",
  _reason: "Reden",
  _secureMessage: "Beveiligd bericht",
  _send: "Verstuur",
  _sendCode: "Verzend code",
  _subject: "Onderwerp",
  _submit: "Verstuur",
  _yourname: "Uw naam",
  _tryAgain: "Probeer opnieuw",
  _tryAgainLater: "Probeer later opnieuw",
  _recipient: "Ontvanger",
  _something_went_wrong: "Er ging iets mis",
  _isLoading: "Bezig met laden…",
  _validateCode: "Valideer code",
  _resendCode: "Opnieuw verzenden code",
  _previousPage: "Vorige pagina",
  _back: "Terug",
  _available_until: "Dit bericht is beschikbaar tot",
  _hours: "uur",

  _error_noAccess: "Geen toegang",
  _error_resend_code: "Wacht %s seconden om een code opnieuw te verzenden.",
  _error_validation_rate_limit: "Te veel mislukte pogingen. Wacht %s seconden voordat u het opnieuw probeert.",
  _error_codeincorrect: "Ingevoerde code is ongeldig",
  _error_messageNotFound: "Dit bericht is niet meer beschikbaar. Het is verlopen of ingetrokken. ",
  _error_messagePhoneIsMissing:
    "We hebben geen telefoonnumer om uw identiteit vast te stellen, neem a.u.b. contact op met de verzender.",
  _error_registeredCodeExpired: "Ingevoerde code is niet meer geldig. Een nieuwe code is naar u toegezonden.",
  _error_addressNotFound: "Adres niet gevonden",
  _error_messageNoDigid:
    "Het is voor dit bericht niet mogelijk om uw identiteit vast te stellen door aan te melden met DigiD.",
  _error_messageNoAuthenticators: "Er zijn geen aanmeld mogelijkheden voor dit bericht",
  _error_password_incorrect: "Wachtwoord onjuist",
  _error_password_missing: "Voer een wachtwoord in",
  _error_password_rate_limit: "Te veel mislukte pogingen. Wacht %s minuut voordat u het opnieuw probeert.",
  _error_password_rate_limit_plural: "Te veel mislukte pogingen. Wacht %s minuten voordat u het opnieuw probeert.",
  _error_phonenumber_exist: " Telefoonnummer is al bekend bij dit e-mail adres",
  _error_phonenumber_invalid: "Ongeldig telefoonnummer",
  Error__Network_Error: "U heeft mogelijk problemen met uw internet verbinding",

  sms_twoFactorMessage: "Uw twee-factor-authenticatie code is: %s",

  form_address_phone_youSendAMessage: "U heeft 1 of meerdere berichten verstuurd naar het emailadres '%s' ",
  form_address_phone_maynotcorrect: "%s is mogelijk niet een juist telefoonnummer",
  form_address_phone_isnotcorrect: "%s is geen correct telefoonnummer",
  form_address_phone_iscorrect: "%s is een correct telefoonnummer",
  form_address_phone_isempty: "Telefoonnummer mag niet leeg zijn",
  form_address_phone_exists: "Dit nummer is al toegevoegd.",
  form_address_phone_submitNumberToDeliver:
    "Voer het mobiel telefoonnummer van deze ontvanger in, zodat deze de toegangscode via SMS kan ontvangen.",
  form_address_phone_phoneNumberIsAdded:
    "Telefoonnummer is toegevoegd aan het emailadres %s. De ontvanger kan nu de toegangscode via SMS ontvangen.",
  form_address_phone_addressAllreadyHasAphone: "Dit emailadres is al voorzien van een telefoonnummer",
  form_address_phone_send: "Verzend telefoonnummer",

  login_introduction_single: "Om dit bericht te lezen, kunt u hier aanmelden.",
  login_introduction_multiple: "Om dit bericht te lezen, kunt u aanmelden middels één van onderstaande opties.",
  login_methods: "Inlogmethoden",

  smslogin_selectPhone: "U kunt een éénmalige toegangscode via SMS naar uw telefoonnummer sturen",
  smslogin_codeIsSend: "Er is een code verzonden naar het telefoonnummer %s. Vul deze code in:",
  smslogin_isNotMyPhone: "Ik heb een ander telefoonnummer",
  smslogin_confirmNotMyPhone:
    "U geeft aan dat u een ander telefoonnummer heeft. Klik op de knop 'Bevestigen' om de verzender van dit bericht op de hoogte te stellen.",
  smslogin_confirmedNotMyPhone:
    "We hebben de verzender op de hoogte gebracht. U kunt zelf geen ander telefoonnummer invoeren. Neem eventueel contact op met de verzender om een ander telefoonnummer door te geven.",

  emailaccesscodelogin_intro: "U kunt een éénmalige toegangscode naar uw e-mailadres sturen.",
  emailaccesscodelogin_code_is_send: "Er is een toegangscode naar uw e-mailadres gestuurd",

  clientcert_title: "Client certificaat",
  clientcert_introduction:
    "U kunt aanmelden door middel van uw client certificaat.<ol>" +
    "<li>Klik op 'Inloggen'.</li>" +
    "<li>Selecteer uw certificaat en klik op OK.</li>" +
    "</ol>",
  clientcert_login: "Inloggen",
  clientcert_cancelled: "Het aanmelden is geannuleerd of er zijn geen bruikbare certificaten geïnstalleerd",
  clientcert_unauthorised: "Het gebruikte certificaat geeft geen toegang tot dit bericht",
  clientcert_error: "Er is een fout opgetreden tijdens het aanmelden",

  digid_introduction:
    'U kunt bij <em>%s</em> aanmelden met DigiD. Heeft u geen DigiD? U kunt deze zelf aanvragen op <a href="https://www.digid.nl/">digid.nl</a>.',
  digid_login: "Aanmelden",
  digid_nodigid: "Ik wil niet aanmelden met DigiD",
  digid_cancelled: "Het aanmelden is geannuleerd",
  digid_unauthorised: "U heeft geen toegang tot dit bericht",
  digid_error: "Er is een fout opgetreden tijdens het aanmelden",

  uzi_introduction:
    "U kunt zich legitimeren door middel van een UZI-pas.<ol>" +
    "<li>Plaats uw UZI-pas in de kaartlezer en wacht tot het groene lampje brandt.</li>" +
    "<li>Klik op 'Inloggen'.</li>" +
    "<li>Selecteer uw certificaat en klik op OK.</li>" +
    "<li>Voer desgevraagd de pincode van de UZI-pas in en klik op OK.</li>" +
    "</ol>",
  uzi_login: "Inloggen",
  uzi_cancelled: "Het aanmelden is geannuleerd",
  uzi_unauthorised: "De gebruikte pas geeft geen toegang tot dit bericht",
  uzi_error: "Er is een fout opgetreden tijdens het aanmelden",

  message_download_all: "Download alle bijlagen",
  message_download_zip: "Download zip",
  message_download_separately: "Download apart",
  message_downloadMessage: "Download bericht",
  message_downloadMessage_eml: "Download eml",
  message_downloadMessage_pdf: "Download pdf",
  message_downloadMessage_zip: "Download zip",
  message_downloadNeedle: "Download %s",
  message_logout: "Afmelden",
  message_reply: "Beantwoorden",
  message_replyAll: "Allen Beantwoorden",
  message_forward: "Doorsturen",

  oidc_ms: "Microsoft OpenID",
  oidc_ms_login: "Login met uw Microsoft Account",

  forward_dialogTitle: "Doorsturen",
  forward_dialogDescription:
    "Het orgineel van dit bericht zal mogelijk onvoldoende beveiligd worden doorgestuurd naar '%s'. Weet u zeker dat u dit wilt doorsturen?",
  compose_originalMessage: "Originele Bericht",
  compose_BackToMessage: "Terug naar het bericht",
  compose_dateSent: "Verzonden",
  compose_to: "Aan",
  compose_dragAndDrop: "Sleep uw bestanden hier of klik om bestanden te selecteren.",
  compose_message: "Bericht",
  compose_attachments: "Bijlagen",
  compose_accepted: "Geaccepteerde bestandsindelingen",
  compose_pleaseWaitMessage:
    "Bijlagen worden nog geüpload. Wacht tot deze uploads zijn voltooid voordat u uw bericht verzendt.",
  compose_sent_success: "Bericht succesvol verzonden.",
  compose_info:
    "U ontvangt dit bericht omdat u een veilig e-mailbericht heeft ontvangen via Bastion 365. De afzender van het bericht gebruikt Bastion 365 om de veiligheid van emailberichten die hij/zij aan u verstuurt te kunnen garanderen.",
  compose_maxMailSize: "Totaal max. grootte: %s MB",
  compose_currentTotalSize: "Huidig totaal: %s %s",
  compose_uploadError: "Kan de volgende een of meer bestanden niet uploaden:",
  compose_uploadHint: "Zorg ervoor dat het bestand van het juiste type is en dat de grootte niet groter is dan %s MB.",
  compose_attachmentSize: "De gecombineerde grootte van uw bijlagen mag niet groter zijn dan %s MB.",
  compose_typeNotAllowed: "Bestanden van het type '%s' met de extensie '%s' zijn niet toegestaan",
  compose_handleSaveError: "Er is een fout opgetreden bij het opslaan van het bericht. Probeer het opnieuw.",
  compose_submissionError: "Er is een fout opgetreden bij het verzenden van het bericht. Probeer het opnieuw.",
  compose_deleteAttachmentError: "Er is een fout opgetreden bij het verwijderen van de bijlage. Probeer het opnieuw.",

  compose_download_copy: "Download kopie",
  compose_download_copy_with_attachments: "Download kopie met bijlagen",

  header_language: "Huidige taal:",

  authenticator_title: "Authenticator",
  authenticator_name:
    "Geef deze authenticator een unieke naam (bijv. gebruikersnaam, mailboxdoel). Deze identifier wordt weergegeven door de authenticator op de inlogpagina.",
  authenticator_edit_name: "Naam bewerken",
  authenticator_generate_qr: "Genereer QR-code",
  authenticator_select: "Selecteer een geregistreerde authenticator:",
  authenticator_intro: "Voer het token in dat wordt gepresenteerd door uw authenticator-app:",
  authenticator_add: "OTP-authenticator toevoegen",
  authenticator_prompt:
    "Scan de onderstaande QR-code en voer het token in dat door uw authenticator is geretourneerd om een MFA-apparaat te registreren bij uw Bastion 365-account.",
  authenticator_added: "Authenticator succesvol toegevoegd.",
  authenticator_confirm_delete: "Bevestig dat u deze authenticator wilt verwijderen.",

  _breaktheglass: "Break the glass",
  _error_breaktheglass_allready_exist: "Break the glass is al uitgevoerd op dit bericht.",
  _error_breaktheglass_hasAllreadyEmailAccessCodeAuth: "Break the glass is niet beschikbaar voor dit bericht.",
  breaktheglass_completed:
    "Het bericht is verzonden met e-mail toegangscode, de ontvanger kan het openen zonder mobiel telefoonnummer.",
  _breaktheglass_other_messages_single: "Er is nog 1 ander openstaand bericht van u naar deze ontvanger.",
  _breaktheglass_other_messages_multiple: "Er zijn nog {count} andere openstaande berichten van u naar deze ontvanger.",
  _breaktheglass_include_all_single: "Voer break the glass ook uit op dit andere bericht.",
  _breaktheglass_include_all_multiple: "Voer break the glass ook uit op deze andere berichten.",
  _breaktheglass_notification_note_single: "Let op: hierdoor wordt ook dit bericht verzonden met e-mail toegangscode.",
  _breaktheglass_notification_note_multiple: "Let op: hierdoor worden ook deze {count} berichten verzonden met e-mail toegangscode.",
  breaktheglass_intro:
    "Met break the glass wordt de ontvanger van het eDelivery bericht direct genotificeerd en kan met een e-mail toegangscode inloggen.",

  Netherlands: "Nederlands",
  English: "Engels",
  _back_to_msg: "Terug naar het bericht",
  passwordTitle: "Wachtwoord",
  passwordHeading: "Uw wachtwoord",
  passwordPlaceholder: "Wachtwoord invoeren…",

  _download_modal_title: "Download bestanden apart",
  _download_modal_body_1: "U downloadt ",
  _download_modal_body_2: " bijlagen naar uw apparaat"
};

export default nl;
